import { render, staticRenderFns } from "./NaturezaDespesaForm.vue?vue&type=template&id=97968050"
import script from "./NaturezaDespesaForm.vue?vue&type=script&lang=js"
export * from "./NaturezaDespesaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports